<template>
    <div class="Member">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>회원정보입력</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <div class="contents-area-slidePanel mrg-btm-120">
            <h2 class="header-title">회원정보입력</h2>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-title"><span>아이디</span></div>
                    <div class="input-item">
                        {{ $store.state.userId }}
                    </div>
                </div>
            </div>
            <div class="form-box">
                <div class="input-title"><span>비밀번호</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="password"
                               placeholder="비밀번호 (6자 ~ 12자 이내)"
                               maxlength="12"
                               v-model="strPassWd" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg" v-show="errorField == 'strPassWd'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span></span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="password"
                               placeholder="비밀번호 재확인"
                               maxlength="12"
                               v-model="strPassWdConfirm" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg" v-show="errorField == 'strPassWdConfirm'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box mrg-top-35">
                <div class="input-title"><span>매장이름</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="매장이름"
                               v-model="strAgentName" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strAgentName'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span>매장주소</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               readonly="readonly"
                               disabled="disabled"
                               v-model="strZipCode"
                               placeholder="주소입력" />
                    </div>
                    <div class="input-item input-item-button">
                        <button class="btn-confirm"
                                @click="postCodeSlideView">
                            주소찾기
                        </button>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strZipCode'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span></span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               readonly="readonly"
                               disabled="disabled"
                               placeholder="주소를 입력해주세요."
                               v-model="strAgentAddress1" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strAgentAddress1'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span></span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="상세주소를 입력해주세요."
                               v-model="strAgentAddress2" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strAgentAddress2'" >
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box mrg-top-35">
                <div class="input-title"><span>담당자</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="담당자"
                               v-model="strEmpName" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strEmpName'" >
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span>전화번호</span></div>
                <div class="input-box">
                    <div class="input-item input-item-phone">
                        <select v-model="strPhone1">
                            <option value="">선택</option>
                            <option>010</option>
                            <option>02</option>
                            <option>031</option>
                            <option>032</option>
                            <option>033</option>
                            <option>041</option>
                            <option>042</option>
                            <option>043</option>
                            <option>044</option>
                            <option>051</option>
                            <option>052</option>
                            <option>053</option>
                            <option>054</option>
                            <option>055</option>
                            <option>061</option>
                            <option>062</option>
                            <option>063</option>
                            <option>064</option>
                            <option>0502</option>
                            <option>070</option>
                            <option>0303</option>
                        </select>
                    </div>
                    <span class="input-text">-</span>
                    <div class="input-item">
                        <input type="text"
                               pattern="\d*"
                               placeholder=""
                               v-model.number="strPhone2"
                               v-mask="['########','#######']"
                               inputmode="numeric" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strPhone'">
                    {{errorMsg}}
                </p>
            </transition>
            <h3 class="sub-title">휴대전화</h3>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-item input-item-phone">
                        <select v-model="strPhoneNumber1">
                            <option value="">선택</option>
                            <option>010</option>
                            <option>011</option>
                            <option>016</option>
                            <option>017</option>
                            <option>018</option>
                            <option>019</option>
                        </select>
                    </div>
                    <div class="input-item">
                        <input type="text"
                               placeholder=""
                               pattern="\d*"
                               v-model="strPhoneNumber2"
                               v-mask="['########','#######']"
                               inputmode="numeric" />
                    </div>
                    <div class="input-item input-item-button"
                         v-if="!authSmsConfirmResult">
                        <button class="btn-auth"
                                @click="smsAuthSendFunc">
                            인증
                        </button>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strPhoneNumber2'">
                    {{errorMsg}}
                </p>
            </transition>
            <template v-if="!authSmsConfirmResult">
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-item">
                            <input type="text"
                                   placeholder="인증번호"
                                   pattern="\d*"
                                   v-model="strCertCodeConfirm"
                                   v-mask="'######'"
                                   inputmode="numeric" />
                        </div>
                        <div class="input-item input-item-button">
                            <button class="btn-confirm"
                                    @click="smsAuthCheckFunc">
                                확인
                            </button>
                        </div>
                    </div>
                </div>
                <transition name="fade">
                    <p class="error-msg"
                       v-show="errorField == 'strCertCodeConfirm' || errorField == 'strConfirmCode'">
                        {{errorMsg}}
                    </p>
                </transition>
            </template>
            <template v-else>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-item" style="color:#017ff0">
                            {{ $store.state.messagesList.THE_NUMBER_YOU_ENTERED_HAS_BEEN_VERIFIED }}
                        </div>
                    </div>
                </div>
            </template>

            <div class="form-box">
                <div class="input-title"><span>팩스번호</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="팩스번호를 입력해 주세요."
                               v-model="strAgentFax" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strAgentFax'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-title"><span>이메일</span></div>
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="이메일를 입력해 주세요."
                               v-model="strEmail" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strEmail'">
                    {{errorMsg}}
                </p>
            </transition>
            <h2 class="header-title">사업자 정보</h2>
            <p>사업자 정보는 PC에 로그인하여 입력해 주세요.</p>
            <div class="buisness-area">
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>사업자명</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strSaupName }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>등록번호</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strAgentNo }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>업종</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strAgentKind }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>업태</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strAgentType }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>대표자명</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strSaupCeo }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>사업자주소</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strAgentAddress }}</div>
                    </div>
                </div>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-title"><span>대표이메일</span></div>
                        <div class="input-item">{{ businessOperatorInfo.strSaupEmail }}</div>
                    </div>
                </div>
            </div>
            <footer class="flex justify-between ">
                <button class="btn-big btn-white mrg-right-10"
                        @click="slidePanelClose">
                    취소
                </button>
                <button class="btn-big btn-bule"
                        @click="formSendFunc">
                    수정완료
                </button>
            </footer>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Member',
    data() {
        return {
            businessOperatorInfo:[],        // 사업자정보
            strPassWd:'',                   // 비밀번호
            strPassWdConfirm:'',            // 비밀번호 (확인)
            strAgentName:'',                // 매장이름
            strZipCode:'',                  // 매장주소 ( 우편번호 )
            strAgentAddress1:'',            // 매장주소 ( 시구동)
            strAgentAddress2:'',            // 매장주소 ( 상세주소)
            strEmpName:'',                  // 담당자이름
            strPhone1:'',                   // 매장 전화번호1
            strPhone2:'',                   // 매장 전화번호2
            strPhoneNumber1:"010",          // 담당자 휴대폰 번호 - 식별번호
            strPhoneNumber2:'',             // 담당자 휴대폰 번호 - 고유번호
            strConfirmCode:'',              // 인증번호 ( 서버에서 전달한 코드)
            strCertCodeConfirm:'',          // 인증번호 ( 사용자 입력번호 )
            authSmsConfirmResult:false,     // 인증여부
            strAgentFax:'',                 // 매장 팩스번호
            strEmail:'',                    // 담당자 이메일 주소
            errorField:'',                  // error 항목
            errorMsg:'',                    // error 메시지
        }
    },
    // 감시자
    watch: {
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getMemberMeInfoFunc();
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 회원정보
        getMemberMeInfoFunc(){
            let param = {};
            this.ajaxGetAuth('/api/v1/member/me/info', param, this.getMemberMeInfoFuncResult);
        },
        // 회원정보 결과
        getMemberMeInfoFuncResult(response) {
            if (response.result.code == 0){
                this.businessOperatorInfo = response.oMyInfo.businessOperatorInfo;

                this.strAgentName = response.oMyInfo.generalInfo.strAgentName;
                this.strZipCode = response.oMyInfo.generalInfo.strZipCode;
                this.strAgentAddress1 = response.oMyInfo.generalInfo.strAgentAddress1;
                this.strAgentAddress2 = response.oMyInfo.generalInfo.strAgentAddress2;
                this.strAgentFax = response.oMyInfo.generalInfo.strAgentFax;
                this.strEmpName = response.oMyInfo.generalInfo.strEmpName;
                let strPhone = response.oMyInfo.generalInfo.strPhone.split('-');
                this.strPhone1 = strPhone[0];
                this.strPhone2 = strPhone[1]+strPhone[2];

                this.strEmail = response.oMyInfo.generalInfo.strEmail;

                if (response.oMyInfo.generalInfo.strEmpPhone.includes('-')){
                    this.strPhoneNumber1 = response.oMyInfo.generalInfo.strEmpPhone.split('-')[0];
                    this.strPhoneNumber2 = response.oMyInfo.generalInfo.strEmpPhone.split('-')[1]+response.oMyInfo.generalInfo.strEmpPhone.split('-')[2];
                }else{
                    this.strPhoneNumber1 = response.oMyInfo.generalInfo.strEmpPhone.substring(0,3);
                    this.strPhoneNumber2 = response.oMyInfo.generalInfo.strEmpPhone.substring(3,13);
                }
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 인증번호 발송
        smsAuthSendFunc(){
            this.strConfirmCode = '';

            let formData = new FormData();
            formData.append('strPhoneNumber', this.strPhoneNumber1+this.strPhoneNumber2);

            this.ajaxPost('/api/v1/join/sendSms', formData,this.smsAuthSendFuncResult);
        },
        // 인증번호 발송 결과
        smsAuthSendFuncResult(response){
            let result = response.result;
            this.toastMsg(result.resultNoti.message,1500)
            if (result.code == 0){

                this.strConfirmCode = result.strCertCode;
            }
        },
        // 인증번호 확인
        smsAuthCheckFunc(){
            if (!this.strConfirmCode){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.PLEASE_ENTER_THE_AUTHENTICATION_NUMBER_RECEIVED;
                return false;
            }
            if (!this.strCertCodeConfirm){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.PLEASE_ENTER_THE_AUTHENTICATION_NUMBER;
                return false;
            }
            if (this.strConfirmCode != this.strCertCodeConfirm){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.THE_AUTHENTICATION_NUMBER_DOES_NOT_MATCH;
                return false;
            }
            this.authSmsConfirmResult = true;
        },
        // 회원정보 저장
        formSendFunc(){
            let formData = new FormData();
            formData.append('strPassWd', this.strPassWd);
            formData.append('strPassWdConfirm', this.strPassWdConfirm);
            formData.append('strAgentName', this.strAgentName);
            formData.append('strZipCode', this.strZipCode);
            formData.append('strAgentAddress1', this.strAgentAddress1);
            formData.append('strAgentAddress2', this.strAgentAddress2);
            formData.append('strEmpName', this.strEmpName);
            //formData.append('strPhone', this.strPhone);
            formData.append('strPhone', this.strPhone1+this.strPhone2);
            formData.append('strPhoneNumber1', this.strPhoneNumber1);
            formData.append('strPhoneNumber2', this.strPhoneNumber2);
            formData.append('strConfirmCode', this.strConfirmCode);
            formData.append('strCertCodeConfirm', this.strCertCodeConfirm);
            formData.append('strAgentFax', this.strAgentFax);
            formData.append('strEmail', this.strEmail);

            this.ajaxPostAuth('/api/v1/member/me/modify', formData,this.formSendFuncResult);
        },
        // 회원정보 저장 결과
        formSendFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.slidePanelClose();
            }else{
                if (result.resultNoti.type == 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
        // 우편번호 선택 결과
        setPostCode(result){
            this.strZipCode = result.zipcode;
            this.strAgentAddress1 = result.address;
        },
    }
}
</script>

<style scoped>
    .error-msg {padding-left: 0;}
    .btn-auth{background-color: #a0a0a0;color: #fff;width: 100%;border: 0;height: 100%;border-radius: 5px;font-size: 16px;}
    .btn-confirm {background-color: #00b7ee;color: #fff;width: 100%;border: 0;height: 100%;border-radius: 5px;font-size: 16px;}
    .form-box {color: #000;}
    .sub-title {color: #000; font-size: 16px; margin-top: 20px; font-weight: 400}
    .buisness-area .input-title {flex-basis: 100px;}
    footer {position: fixed !important; bottom: 0px;left: 0;right: 0;border-top: 1px solid #dfdfdf;padding: 20px 10px; background: #fff}
</style>
